import React from "react";

import Skeleton from "react-loading-skeleton";
import "react-loading-skeleton/dist/skeleton.css";

function UnitSkelton() {
  return (
    <div className="subNav-link">
      <div className="nav-title-wrap">
        <Skeleton
          circle
          containerClassName="course-unit-icon"
          width="100%"
          height="100%"
        />
        <Skeleton height={24} containerClassName="nav-title w-100" count={1} />
      </div>
    </div>
  );
}

export default UnitSkelton;
